// src/components/Layout/PrivateLayout.tsx
import { FC, PropsWithChildren, Suspense } from "react";
import { Navigate, Outlet } from "react-router-dom";
import * as Sentry from "@sentry/react";
import MainLayout from "@/components/Layout/MainLayout";
import LoadingFallback from "@/components/ui/LoadingFallback";
import SentryFallback from "@/components/ui/SentryFallback";
import { useAuth } from "@/contexts/AuthContext";
import CloudConfigInitializer from "@/components/Layout/CloudConfigInit";

const PrivateLayout: FC = () => {
  const { isLoading, isAuthenticated } = useAuth();
  if (isLoading) return <LoadingFallback />;
  if (!isAuthenticated) return <Navigate to="/login" replace />;

  return (
    <Sentry.ErrorBoundary fallback={<SentryFallback />}>
      <MainLayout>
        <CloudConfigInitializer />
        <Suspense fallback={<LoadingFallback />}>
          <Outlet />
        </Suspense>
      </MainLayout>
    </Sentry.ErrorBoundary>
  );
};

export default PrivateLayout;
